<template>
    <div class="carousel-view">
            <v-container fluid>
                <v-row align="center">
                <v-col cols="12">
                    <div class="profile-header">
                    {{ displayMode }} pictures <span v-if="displayMode == 'collective' || displayMode =='user'">by</span><span v-else>in</span><span class="display-name"> {{ id || 'main' }}</span>
                    </div>
                    <div class="image-container">
                    <div class="hero">
                        <v-img 
                            :src="images[current].display" 
                            contain
                            :lazy-src="images[current].gallery"
                            >
                            <template v-slot:placeholder>
                                <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                                >
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                </v-row>
                            </template>
                        </v-img>
                    </div>
                   
                    <div class="meta">
                         <div class="meta-score">
                            {{ images[current].votes_count }} <span>{{ images[current].votes_count + 90 }}</span>
                         </div>
                         <div class="meta-text">
                             <strong>{{ images[current].title }}</strong> <br /> by <router-link :to="{ name: 'user-gallery', params: { id: images[current].user }}">{{ images[current].user }}</router-link>
                        </div>
                        <div class="meta-icons">
                            <Icons            
                                v-bind:image="images[current]"
                            />
                        </div>
                    </div>
                    <div class="navigation">
                        <span @click="setCurrent(-1)">previous</span> | <span @click="setCurrent(1)">next</span>
                    </div>
                    </div>
                </v-col>
                </v-row>
            </v-container>
        </div>
</template>

<script>

import Icons from '@/components/gallery/Icons'
import { userMixin } from '@/functions/mixins'

export default {
    name: "Caroussel",
    props: ['images', 'displayMode'],
    mixins: [userMixin],
    components: {
        Icons
    },
    data() {
        return {
            current: 0
        }
    },
    methods: {
        setCurrent(direction) {
                let max = this.images.length - 1
                let navigate = this.current + direction
                if( navigate > max ) navigate = 0
                if( navigate < 0 ) navigate = max
                this.current = navigate
            },
    },
    created() {
            this.$watch(
                () => this.$route.params,
                (toParams) => {
                    // this.setCurrent(0)
                    this.id = toParams.id
                }
            )
        } 
}
</script>